export * from "-!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../node_modules/framevuerk-builder/node_modules/pug-html-loader/lib/index.js!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvPagination.vue?vue&type=template&id=68ecd37a&lang=pug&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvPagination.vue?vue&type=template&id=68ecd37a&lang=pug&
// module id = 192
// module chunks = 0 1